export default "__VITE_ASSET__Bbl5N3PC__"